import { render, staticRenderFns } from "./AddImagemBannerComponent.vue?vue&type=template&id=6f2b5ff3&scoped=true"
import script from "./AddImagemBannerComponent.vue?vue&type=script&lang=js"
export * from "./AddImagemBannerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2b5ff3",
  null
  
)

export default component.exports